export function getOrderedCategoryMap(docs) {
  return docs.reduce((acc, doc, index) => {
    const key = `${doc.category}_${doc.subcategory}`;
    if (!acc[key]) {
      acc[key] = Object.keys(acc).length + 1; // Increment the index for each unique key
    }
    return acc;
  }, {});
}
